module.exports = __webpack_public_path__ + "img/num_43.b1662a2c.png";